import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import AuthLayout from '../../components/auth/AuthLayout';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { authService } from '../../services/authService';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [err, setErr] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setMessage(null);
    setSubmitting(true);
    try {
      const res = await authService.forgotPassword(email.trim());
      setMessage(res?.message || 'Se o email existir, enviaremos um link pra redefinir sua senha.');
    } catch (ex) {
      setErr(ex.message || 'Erro ao solicitar reset.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Esqueci minha senha"
      subtitle="Informe seu email cadastrado. Se existir, enviaremos um link de redefinição."
      footer={
        <p className="text-app-text-secondary">
          Lembrou?{' '}
          <Link to="/entrar" className="text-primary hover:underline font-semibold">
            Entrar
          </Link>
        </p>
      }
    >
      {message && (
        <div className="bg-success/10 border border-success/30 text-success px-4 py-3 rounded-lg mb-4 text-sm">
          {message}
        </div>
      )}
      {err && (
        <div className="bg-error/10 border border-error/30 text-error px-4 py-3 rounded-lg mb-4 text-sm">
          {err}
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="email"
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="seu@email.com"
          leftIcon={<Mail size={18} />}
        />
        <Button type="submit" fullWidth loading={submitting} size="lg">
          Enviar link
        </Button>
      </form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
